import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import BlogPost from "../components/blog-post"
import CoupangLinkDiv from "../components/coupang-link"

import '../styles/code.scss'
class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const metaData = this.props.data.site.siteMetadata
    const siteTitle = metaData.title
    const { comment, sponsor } = metaData
    const { utterances } = comment

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <BlogPost
          html={post.html}
          frontmatter={post.frontmatter}
          description={post.excerpt}
          pageContext={this.props.pageContext}
          sponsor={sponsor}
          utterances={utterances}
        >
        </BlogPost>
        <CoupangLinkDiv post={post}></CoupangLinkDiv>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
        comment {
          utterances
        }
        sponsor {
          buyMeACoffeeId
        }
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 300)
      html
      fileAbsolutePath
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        tags
        category
      }
    }
  }
`
